import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import React, { useEffect, useState } from 'react';
import { DateTimePickerArrival } from '../styled';
import moment from 'moment';

const AppDatePicker = <T extends Record<string, any>>(props: IAppDatePickerProps<T>) => {
    const { placeholder, minDate, maxDate, onArrivalDateChange, ...rest } = props;

    const [value, setValue] = useState<moment.Moment | null>(props.value ?? null);

    useEffect(() => {
        setValue(props.value ?? null);
    }, [props.value]);

    const onDateChange = (val: moment.Moment | null) => {
        if (val && moment.isMoment(val) && val.isValid()) {
            setValue(val);
            onArrivalDateChange?.(val);
        } else {
            setValue(null);
            onArrivalDateChange?.(null);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DateTimePickerArrival
                {...rest}
                value={value}
                slotProps={{
                    textField: {
                        fullWidth: true,
                        placeholder: placeholder,
                        InputLabelProps: { shrink: true },
                        error: rest.error,
                        helperText: rest.helperText,
                        sx: {
                            '& .MuiInputBase-input::placeholder': { color: 'gray', opacity: 0.7 },
                            '& .MuiInputLabel-root': {
                                color: 'var(--color-49454f)',
                                fontSize: '18px',
                                fontWeight: '400',
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'var(--sp-gray-1)',
                                },
                                '&:hover fieldset': {
                                    borderColor: 'var(--color-border-hover)',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: 'var(--color-primary)',
                                },
                                '&.Mui-disabled fieldset': {
                                    borderColor: 'var(--color-bababa)',
                                },
                            },
                        },
                    },
                }}
                onChange={onDateChange}
                minDate={minDate ?? undefined}
                maxDate={maxDate ?? undefined}
            />
        </LocalizationProvider>
    );
};

export default AppDatePicker;
